<template>
  <div>
      <!--返回列表按钮-->
      <div style="margin:0 0 10px 10px;">
        <Icon type="chevron-left"></Icon>
        <a @click='backPage'>{{ $t('common.backToList') }}</a>
      </div>
      <div style="background-color: #fff;margin:0 10px 0 10px;padding:10px 0 0 10px;">
        <div style="margin-top:10px;background-color:#F3F3F4;height:30px;line-height: 35px;">
            <span style="font-size: 15px;font-weight: bold;margin-left: 5px;margin-top: 5px;">{{ selectAccessTime }} 总调用量：{{ selectTotalTimes }}</span>
        </div>
        <div width="98%" class="platformSearch card-content" style="border-width:2px;border-color: #F3F3F4;margin-top:10px;">
            <dTable highlight-row :columns="accessStatisticsDetailColumns" :data="accessStatisticsDetailData" :height="tableHeight"  style="cursor:pointer;"></dTable>
        </div>
        <div class='fr' style="margin:20px 0;">
          <Button @click="backPage" style="margin-right:10px;" icon="close-round">{{$t('common.cancel')}}</Button>
        </div>
      </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  props: ['accessStatisticsId', 'selectAccessTime', 'selectTotalTimes'],
  mixins: [ Mixin, tableMixin ],
  components: {

  },
  data () {
    let self = this;
    return {
      loading2: false,
      accessStatisticsDetailData: [],
      accessStatisticsDetailColumns: [
        {
          title: self.t('common.callMethod'),
          align: 'center',
          key: 'callMethod'
        },
        {
          title: self.t('common.totalTimes') + '/天',
          align: 'center',
          key: 'totalTimes'
        }
      ]
    };
  },
  methods: {
    // 返回列表
    backPage () {
      this.$parent.workShow = 'list';
    },
    getDetail () {
      let v = this;
      v.accessStatisticsDetailData = [];
      v.axios.get(api.accessStatistics_detail + '?accessStatisticsId=' + v.accessStatisticsId + '&date=' + new Date().getTime()) // 获取物流商列表
        .then(response => {
          if (response.data.code === 0) {
            v.accessStatisticsDetailData = response.data.datas;
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    }

  },
  created () {
    let v = this;
    v.tableHeight = this.getTableHeight(240);
    v.getDetail();
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/accessStatisticsDetail.vue